'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertRegular, Home20Regular, LayoutRowFour24Regular } from '@fluentui/react-icons';
import { Badge, Box, Button, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import array1 from '@public/assets/images/array1.png';
import useHeaderStyles from './useHeaderStyles';
import SelectProjectDialog from '@ui/components/Dialogs/SelectProjectDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import Alerts from '@ui/components/alerts';
import * as signalR from '@microsoft/signalr';
import IncidentAPI from '@application/api/endpoints/incident-api';
import { useSelector } from 'react-redux';
import CustomAvatar from '@ui/components/common/CustomAvatar';
const sampleProjects = [
    {
        id: '1',
        name: 'ARRAY1',
        icon: array1
    },
    {
        id: '2',
        name: 'Deltex B.V.',
        icon: '/placeholder.svg?height=24&width=22'
    }
];
const Header = () => {
    const theme = useTheme();
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipKey, setTooltipKey] = useState(0); // <- Add this
    const [alerts, setAlerts] = useState();
    const prevIncidentIdsRef = useRef(new Set());
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [totalAlerts, setTotalAlerts] = useState(0);
    const refreshFlag = useSelector((state) => state.refresh.projects);
    const isLight = theme.palette.mode === 'light';
    const navigate = useNavigate();
    const { headerContainerStyles, logoContainerStyles, optionsContainerStyles, accessButtonStyles, optionContainerStyles, notificationButtonStyles, profileInfoContainerStyles } = useHeaderStyles();
    const [selectProjectDialog, setSelectProjectDialog] = useState({
        show: false,
        title: 'Select Project'
    });
    const location = useLocation();
    const apiUrl = process.env.REACT_APP_API_URL;
    const baseUrl = apiUrl?.replace(/\/api\/?$/, '');
    const [selectedProject, setSelectedProject] = useState(undefined);
    const [fullAccess, setFullAccess] = useState(false);
    const { user } = useSelector((state) => state.authSlice);
    const initials = (() => {
        if (!user?.name)
            return '';
        const parts = user.name.trim().split(' ').filter(Boolean);
        if (parts.length === 0)
            return '';
        if (parts.length === 1)
            return parts[0][0].toUpperCase();
        return (parts[0][0] + parts[1][0]).toUpperCase();
    })();
    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${baseUrl}/notificationHub`)
            .withAutomaticReconnect()
            .build();
        connection.start().catch(() => { });
        connection.on('ReceiveNotification', (message) => {
            setTotalAlerts(message?.allIncidentAlert?.length || 0);
            setAlerts(message);
            if (message?.criticalIncidentAlert?.length > 0) {
                const currentCriticalAlerts = message?.criticalIncidentAlert || [];
                setTotalAlerts(message?.allIncidentAlert?.length || 0);
                setAlerts(message);
                const currentIds = new Set(currentCriticalAlerts.map((alert) => alert.incidentId));
                const previousIds = prevIncidentIdsRef.current;
                const hasNewId = [...currentIds].some((id) => !previousIds.has(id));
                if (hasNewId) {
                    setShowTooltip(true);
                }
                prevIncidentIdsRef.current = currentIds;
            }
        });
        return () => {
            connection.stop();
        };
    }, []);
    useEffect(() => {
        const getIncidentAlerts = async () => {
            try {
                const response = await IncidentAPI.getIncidentAlerts();
                if (response.isSuccess && response?.data) {
                    setTotalAlerts(response?.data?.allIncidentAlert.length || 0);
                    setAlerts(response.data);
                    if (response?.data.criticalIncidentAlert?.length > 0) {
                        setShowTooltip(true);
                    }
                }
            }
            catch (error) { }
        };
        getIncidentAlerts();
    }, [refreshFlag]);
    const handleCloseSelectProjectDialog = () => {
        setSelectProjectDialog((prev) => ({ ...prev, show: false, title: '' }));
    };
    const { alertDrawer } = useSelector((state) => state.incidentDetail);
    useEffect(() => {
        setDrawerOpen(false);
    }, [alertDrawer]);
    const handleSelectProject = (projectId) => {
        setSelectedProject(projectId);
        setFullAccess(false);
        handleCloseSelectProjectDialog();
    };
    const handleProjectDetails = () => {
        navigate('/projects');
    };
    const handleNotificationClick = () => {
        setDrawerOpen(true);
    };
    return (_jsxs(Box, { id: 'header-top', className: 'header', sx: headerContainerStyles, children: [_jsx("img", { src: isLight ? '/assets/images/logo.svg' : '/assets/svgs/logo-dark-mode.svg', height: isLight ? 35 : 64, alt: 'logo' }), _jsxs(Box, { className: 'options-container', sx: optionsContainerStyles, children: [_jsx(Box, { children: _jsx(Button, { variant: 'outlined', color: isLight ? 'primary' : 'inherit', size: 'medium', startIcon: _jsx(LayoutRowFour24Regular, {}), sx: accessButtonStyles, onClick: handleProjectDetails, children: "Project Details" }) }), location.pathname.includes('projects') && (_jsx(Button, { variant: 'outlined', size: 'medium', color: 'inherit', className: 'access-button', sx: accessButtonStyles, onClick: () => {
                            navigate('/dashboard');
                        }, startIcon: _jsx(Home20Regular, {}), children: "Return Home" })), _jsxs(Box, { className: 'options-container', sx: optionContainerStyles, children: [_jsx(Tooltip, { open: alerts?.criticalIncidentAlert?.length != null &&
                                    alerts?.criticalIncidentAlert?.length > 0
                                    ? showTooltip
                                    : false, title: `${alerts?.criticalIncidentAlert?.length} Severe Incident detected`, placement: 'bottom', arrow: true, PopperProps: {
                                    disablePortal: true,
                                    modifiers: [
                                        {
                                            name: 'zIndex',
                                            enabled: true,
                                            phase: 'write',
                                            fn({ state }) {
                                                state.styles.popper.zIndex = `${theme.zIndex.drawer - 1}`;
                                            }
                                        }
                                    ]
                                }, componentsProps: {
                                    tooltip: {
                                        className: 'shake-tooltip',
                                        sx: {
                                            bgcolor: 'error.main',
                                            color: 'common.white',
                                            zIndex: `${theme.zIndex.drawer - 1} !important`,
                                            fontSize: 12,
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 1
                                        }
                                    },
                                    arrow: {
                                        sx: {
                                            color: 'error.main'
                                        }
                                    }
                                }, children: _jsx(IconButton, { className: 'notification-btn', onClick: handleNotificationClick, sx: notificationButtonStyles, children: _jsx(Badge, { color: 'error', badgeContent: totalAlerts, showZero: true, children: _jsx(AlertRegular, { fontSize: 24, color: theme.palette.action.active }) }) }) }, tooltipKey), _jsxs(Box, { className: 'user-info-container', sx: profileInfoContainerStyles, children: [_jsx(CustomAvatar, { initials: initials }), _jsx(Typography, { variant: 'body1', color: 'textSecondary', children: user?.name })] })] })] }), selectProjectDialog.show && (_jsx(SelectProjectDialog, { isOpen: selectProjectDialog.show, projects: sampleProjects, selectedProject: selectedProject, onClose: handleCloseSelectProjectDialog, onSelectProject: handleSelectProject })), _jsx(Alerts, { open: isDrawerOpen, handleClose: () => setDrawerOpen(false), alerts: alerts, setAlerts: setAlerts })] }));
};
export default Header;
